export const OPBooleanOptions = [
    { value: 'true', label: "Yes" },
    { value: 'false', label: "No" },
];

export const OPLogicalOperators = [
    { value: 'and', label: "AND" },
    { value: 'or', label: "OR" },
];

export const OPProgramCost = [
    { value: 'one-star', label: "1 Star" },
    { value: 'two-star', label: "2 Stars" },
    { value: 'three-star', label: "3 Stars" },
];

export const OPProgramDifficulty = [
    { value: 'easy', label: "Easy" },
    { value: 'moderate', label: "Moderate" },
    { value: 'hard', label: "Hard" },
];

export const OPProgramTimeframe = [
    { value: '0-1-month', label: "Less than a month" },
    { value: '1-3-month', label: "1-3 Months" },
    { value: '3-6-month', label: "3-6 Months" },
    { value: '6month+', label: "6 Months+" },
];

export const OPEmployerTypes = [
    { value: "corporation", label: "Corporation" },
    { value: "non-profit", label: "Non-profit" },
    { value: "unincorporated", label: "Unincorporated" },
    { value: "partnership", label: "Partnership" },
];

export const OPLMIAInPastOptions = [
    { value: 'true', label: "Yes" },
    { value: 'false', label: "No" },
    { value: 'null', label: "Not Sure" },
];

export const OPNAICS = [
    { value: "Accommodation and food services (hospitality)", label: "Accommodation and food services (hospitality)" },
    { value: "Administrative, waste management and remediation services", label: "Administrative, waste management and remediation services" },
    { value: "Agriculture, forestry, fishing and hunting", label: "Agriculture, forestry, fishing and hunting" },
    { value: "Arts, entertainment and recreation", label: "Arts, entertainment and recreation" },
    { value: "Construction", label: "Construction" },
    { value: "Educational services", label: "Educational services" },
    { value: "Finance and insurance", label: "Finance and insurance" },
    { value: "Health care and social assistance", label: "Health care and social assistance" },
    { value: "Information and cultural industries", label: "Information and cultural industries" },
    { value: "Management of companies and enterprises", label: "Management of companies and enterprises" },
    { value: "Manufacturing", label: "Manufacturing" },
    { value: "Mining, quarrying, and oil and gas extraction", label: "Mining, quarrying, and oil and gas extraction" },
    { value: "Professional, scientific and technical services", label: "Professional, scientific and technical services" },
    { value: "Real estate and rental and leasing", label: "Real estate and rental and leasing" },
    { value: "Retail trade", label: "Retail trade" },
    { value: "Transportation and warehousing", label: "Transportation and warehousing" },
    { value: "Utilities", label: "Utilities" },
    { value: "Wholesale trade", label: "Wholesale trade" },
    { value: "Other", label: "Other" },
    { value: "Not sure", label: "Not sure" },
];

export const OPOrganizationStatuses = [
    { value: "setup", label: "Setup" },
    { value: "trial", label: "Trial" },
    { value: "active", label: "Active" },
    { value: "disabled", label: "Disabled" },
];

export const OPUserRoles = [
    { value: "admin", label: "Admin" },
    { value: "staff", label: "Staff" },
];

export const OPUserStatuses = [
    { value: "active", label: "Active" },
    { value: "disabled", label: "Disabled" },
];